import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { AuthEventType } from "@/types/auth";
import useEmblaCarousel from "embla-carousel-react";
import React, { useEffect, useState } from "react";

type CarouselFormProps = {
  slide?: number;
  items: CarouselFormItemProps[];
};

export type CarouselFormItemProps = {
  value: string;
  component: React.FC<CarouselSlide>;
};

export type CarouselSlide = {
  onPrev?: () => void;
  emblaApi: ReturnType<typeof useEmblaCarousel>[1];
};

export const CarouselForm: React.FC<CarouselFormProps> = ({ slide = 0, items }) => {
  const authActorRef = AuthMachineContext.useActorRef();
  const [startIndex] = useState(slide);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    startIndex,
    watchDrag: false
  });

  useEffect(() => {
    emblaApi?.scrollTo(slide);
  }, [slide, emblaApi]);

  return (
    <div className="embla flex flex-1 flex-col" ref={emblaRef}>
      <div className="embla__container flex-1">
        {items.map(({ value, component }) => {
          return (
            <div className="embla__slide flex flex-1 flex-col" key={value}>
              {React.createElement(component, {
                emblaApi,
                onPrev: () => {
                  authActorRef.send({
                    type: AuthEventType.PREVIOUS_STEP
                  });
                }
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
